import { Outlet, createFileRoute } from '@tanstack/react-router';

import { DashboardLayoutV2 } from 'src/components/layout/dashboard-layout/dashboard-layout-v2';

import { StaffGate } from 'src/sections/staff/staff-gate';

/**
 * The internal work surface.
 *
 * Outside `_authed` on purpose, the way `admin-skidog` is: that layout gates on
 * a completed organization and mounts a subscription provider, neither of which
 * a NexMail employee has. The auth check they do share lives in `StaffGate`.
 */
export const Route = createFileRoute('/w')({
  component: WorkLayout,
});

function WorkLayout() {
  return (
    <StaffGate>
      <DashboardLayoutV2>
        <Outlet />
      </DashboardLayoutV2>
    </StaffGate>
  );
}
